import { Measure } from 'services/model/model.service';
import { DataEntry } from 'models/data';

export interface DrillDownTableDateGmvValues {
  share: number;
  dayValue: number;
  dayDelta: number;
  dayWeekBefore: number;
  weekDelta: number;
  weekValue: number;
  weekWeekBefore: number;
  fourWeekAvg: number;
  fourWeekAvgDelta: number;
}

export const extractDrillDownTableDateGmvValues = (
  entry: DataEntry,
  parentTotal: number,
  measure: Measure
): DrillDownTableDateGmvValues => {
  const dayValue = measure.getValue(entry.additionalRanges?.onDayRange?.values);
  const weekValue = measure.getValue(entry.additionalRanges?.onWeekRange?.values);
  const fourWeekAvg =
    (measure.getValue(entry.additionalRanges?.onDayRange?.compareValues) +
      measure.getValue(entry.additionalRanges?.onWeek2?.values) +
      measure.getValue(entry.additionalRanges?.onWeek3?.values) +
      measure.getValue(entry.additionalRanges?.onWeek4?.values)) /
    4;
  const dayWeekBefore = measure.getValue(entry.additionalRanges?.onDayRange?.compareValues);
  const weekWeekBefore = measure.getValue(entry.additionalRanges?.onWeekRange?.compareValues);

  return {
    share: parentTotal ? dayValue / parentTotal : 0,
    dayValue,
    dayDelta: dayValue - dayWeekBefore,
    dayWeekBefore,
    weekDelta: weekValue - weekWeekBefore,
    weekValue,
    weekWeekBefore,
    fourWeekAvg,
    fourWeekAvgDelta: dayValue - fourWeekAvg,
  };
};
